import { Input } from '@angular/core'
import { Component } from '@angular/core'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { FlexGrid } from '@grapecity/wijmo.grid'
import { FlexGridPdfConverter } from '@grapecity/wijmo.grid.pdf'
import { PdfDocument, saveBlob } from '@grapecity/wijmo.pdf'

@Component({
    selector: 'grid-pdf-export',
    templateUrl: './grid-pdf-export.component.html',
    standalone: true,
    imports: [FaIconComponent],
})
export class GridPdfExportComponent {
    faFilePdf = faFilePdf
    @Input() grids!: FlexGrid[]
    @Input() name!: string
    @Input() names!: string[]
    export() {
        const doc = new PdfDocument({
            header: {
                declarative: {
                    text: '',
                    //text: '\t&[Page]\\&[Pages]'
                },
            },
            footer: {
                declarative: {
                    text: '\t&[Page]\\&[Pages]',
                },
            },
            ended: (sender, args) => saveBlob(args.blob, this.name),
        })

        const settings = {
            styles: {
                cellStyle: {
                    backgroundColor: '#ffffff',
                    borderColor: '#c6c6c6',
                },
                altCellStyle: {
                    backgroundColor: '#f9f9f9',
                },
                groupCellStyle: {
                    backgroundColor: '#dddddd',
                },
                headerCellStyle: {
                    backgroundColor: '#eaeaea',
                },
            },
        }

        this.grids.forEach((grid, index) => {
            //if (index != 0)
            //    doc.addPage()
            doc.drawText(this.names[index], undefined, undefined, { width: 200 })

            doc.moveDown(0.5)
            // to draw FlexGrid to Pdf doc to fit the document width
            FlexGridPdfConverter.draw(grid, doc, doc.width, undefined, settings)
            doc.moveDown(2)
        })
        doc.end()
    }
}
